/* @jsxImportSource react */

import { type PropsWithChildren } from 'react';
import { CarouselVirtualizedList } from './CarouselVirtualizedList.client';
import { CarouselProvider } from './CarouselProvider';
import { CarouselWrapper } from './CarouselWrapper.client';
import { CarouselNav } from './CarouselNav.client';

export const Carousel = ({
  children,
  style,
  className,
  listClassName,
}: PropsWithChildren<{
  style?: React.CSSProperties;
  className?: string;
  listClassName?: string;
}>) => (
  <CarouselProvider>
    <CarouselWrapper style={style} className={className}>
      <CarouselNav />
      <CarouselVirtualizedList className={listClassName}>{children}</CarouselVirtualizedList>
    </CarouselWrapper>
  </CarouselProvider>
);
